import React from 'react';
import { SqsPageHeader, SqsButton } from './sqs/SqsShell';
import DashboardMedia from './DashboardMedia';

/** Assets wraps the existing Media Library page so it lives under Website → Assets. */
export default function DashboardAssets() {
  return (
    <>
      <SqsPageHeader
        breadcrumbs="Website"
        title="Assets"
        subtitle="Your media library — uploaded images, videos, and downloadable files."
      />
      <div className="p-10"><DashboardMedia embedded /></div>
    </>
  );
}
